import React from 'react';
import { useRouter } from 'next/router';

import { usePaymentDueQuery } from '@edx/graphql/generated';
import { useDialog } from '@edx/hooks/use-dialog';
import { Modal } from '@edx/components/modal';
import { Body } from '@edx/components/typography';

export const PastDueModal: React.FC = () => {
  const router = useRouter();
  const { show, ref, handleShow, handleHide } = useDialog();
  const [didDismiss, setDidDismiss] = React.useState(false);

  const { data } = usePaymentDueQuery();
  const paymentUrl = data?.paymentDue?.paymentUrl;

  if (!paymentUrl || didDismiss) return null;
  else if (paymentUrl && !show) handleShow();

  const handleDismiss = (): void => {
    setDidDismiss(true);
    handleHide();
  };

  return (
    <Modal
      headline="Ha habido un problema con tu pago"
      primaryButtonText="Solucionar"
      dismissButtonText="Cancelar"
      onDismiss={handleDismiss}
      onPrimaryButtonClick={(): Promise<boolean> => router.push(paymentUrl as string)}
      ref={ref}
    >
      <Body>
        Tu cuenta está desactivada porque ha habido un problema con tu pago. Por favor, actualiza tu forma de pago para
        poder seguir disfrutando de nuestros servicos.
      </Body>
    </Modal>
  );
};
